import { baseRoute } from '../../../constants/routes';
import { QUIZ_ROUTE } from '../constants';

export const PLAYERS_ROUTE = QUIZ_ROUTE + '/players';
export const QUIZ_FILTER_PLAYERS_ROUTE = baseRoute + '/quiz-statistics/filtered-players';
export const QUIZ_PLAYER_CHEATERS_ROUTE = baseRoute + '/cheaters';
export const QUIZ_DELETE_ALL_PLAYERS = baseRoute + '/quizzes/delete-data';
export const PSEUDONONYMIZE_PLAYER_ROUTE = baseRoute + '/pseudononymize';

export const GET_PLAYERS = 'GET_PLAYERS';
export const GET_PLAYERS_SUCCESS = 'GET_PLAYERS_SUCCESS';
export const CLEAR_PLAYERS ='CLEAR_PLAYERS';
export const SET_QUIZ_FILTER_PLAYER='SET_QUIZ_FILTER_PLAYER';
export const SET_QUIZ_FILTER_PLAYER_SUCCESS='SET_QUIZ_FILTER_PLAYER_SUCCESS';

export const DELETE_QUIZ_USER_PLAYER = 'DELETE_QUIZ_USER_PLAYER';
export const DELETE_QUIZ_USER_PLAYER_SECCESS = 'DELETE_QUIZ_USER_PLAYER_SECCESS';

export const PSEUDONONYMIZE_PLAYER = 'PSEUDONONYMIZE_PLAYER';
export const PSEUDONONYMIZE_PLAYER_SECCESS = 'PSEUDONONYMIZE_PLAYER_SECCESS';

export const DOWNLOAD_QUIZ_EXPORT_ROUTE = baseRoute + '/export/QuizLocalization';
export const DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE = 'DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE';
export const DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS = 'DOWNLOAD_QUIZ_PLAYERS_EXPORT_FILE_SUCCESS';

export const DELETE_QUIZ_ALL_USER_PLAYERS = 'DELETE_QUIZ_ALL_USER_PLAYERS';
export const DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS = 'DELETE_QUIZ_ALL_USER_PLAYERS_SUCCESS';